import type { TickRendererProps } from '@visx/axis';

import { useTickTruncation } from './hooks/useTickTruncation.js';
import { useYTickOffset } from './hooks/useYTickOffset.js';
import { Tooltip } from '../../../../overlays/tooltip/Tooltip.js';
import { ForeignObjectWrapper } from '../../../core/components/foreign-object-wrapper/ForeignObjectWrapper.js';
import { useXYChartTruncationMode } from '../../hooks/useXYChartTruncationMode.js';

interface YTickWithTruncationProps {
  position: 'left' | 'right';
  renderProps: TickRendererProps;
  maxSpaceForTruncation: number;
  centerTick: boolean;
}

export function YTickWithTruncation({
  position,
  renderProps,
  maxSpaceForTruncation,
  centerTick,
}: YTickWithTruncationProps) {
  const { formattedValue, x, y } = renderProps;

  const { truncationMode } = useXYChartTruncationMode();

  const {
    displayValue,
    tickClassName,
    tickInlineStyle,
    truncatedWidth,
    truncatedValue,
  } = useTickTruncation(formattedValue, maxSpaceForTruncation, truncationMode);

  const { xOffset, yOffset, style } = useYTickOffset(
    position,
    truncatedWidth,
    renderProps,
    centerTick,
  );

  const showTooltip = truncatedValue === formattedValue;

  return (
    <ForeignObjectWrapper x={x - xOffset} y={y - yOffset} style={style}>
      <Tooltip disabled={showTooltip} text={formattedValue}>
        <span className={tickClassName} style={tickInlineStyle}>
          {displayValue}
        </span>
      </Tooltip>
    </ForeignObjectWrapper>
  );
}
